// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const Carrier = createIcon(
  <path
    clipRule="evenodd"
    d="M10.3303 8.05322V6.425H13.6697V8.05322H10.3303ZM8.53027 8.05322V5.625C8.53027 5.07271 8.97799 4.625 9.53027 4.625H14.4697C15.022 4.625 15.4697 5.07272 15.4697 5.625V8.05322H19C19.5523 8.05322 20 8.50094 20 9.05322V18.375C20 18.9273 19.5523 19.375 19 19.375H5C4.44772 19.375 4 18.9273 4 18.375V9.05322C4 8.50094 4.44772 8.05322 5 8.05322H8.53027Z"
    fillRule="evenodd"
  />,
);
